import { BottomSheet } from '@betty/navigation';
import { startListening, socketConnected } from '@betty/toolkit/state';
import { Notification } from './rewards.types';
import { parseRewards } from './rewards.utils';
import { logInfo } from '@betty/toolkit/logging';

startListening({
  actionCreator: socketConnected,
  effect: (action) => {
    const socketConnection = action.payload;

    socketConnection.on(
      'RewardMessageReceived',
      (notification: Notification) => {
        const { rewards, sourceType } = notification || {};

        logInfo('WS', 'RewardMessageReceived', notification);

        if (
          !rewards ||
          sourceType === 'DailyGift' ||
          sourceType === 'CommunityEventPlayerContributionReward' ||
          sourceType === 'CommunityEventJackpotReward' ||
          sourceType === 'CommunityEventPlayerMilestoneFlipReward' ||
          sourceType === 'ItemPurchase'
        ) {
          return;
        }

        BottomSheet.open({
          namespace: 'rewards',
          type: 'RewardReceivedBottomSheet',
          presentAnimation: 'confetti',
          singleton: false,
          light: true,
          data: {
            rewards: parseRewards(rewards),
            questCompleted: sourceType === 'InPeriod',
          },
          scrollable: true,
          enableContentPanningGesture: false,
        });
      },
    );
  },
});
